import { render, staticRenderFns } from "./ChildProtectionPolicyLess.vue?vue&type=template&id=49f6bd24&scoped=true"
import script from "./ChildProtectionPolicyLess.vue?vue&type=script&lang=js"
export * from "./ChildProtectionPolicyLess.vue?vue&type=script&lang=js"
import style0 from "./ChildProtectionPolicyLess.vue?vue&type=style&index=0&id=49f6bd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6bd24",
  null
  
)

export default component.exports